import { RadioGroup,Radio,Stack, Box,Center } from "@chakra-ui/react"

const MaleFemale=({value="m",size="sm",onChange})=>{

    const handleChange=(event)=>{
        onChange(event.target.value)
    }
    const defVal=value==="f"?"f":"m";
    return (
        <Box borderColor={'grunt2.400'} borderWidth={'2px'} bg={'gray.100'}>
        <RadioGroup defaultValue={defVal} size={size} colorScheme="grunt2">
            <Center>
            <Stack spacing={2} direction='row'>
                <Radio value='m' onChange={handleChange}>
                    M
                </Radio>
                <Radio value='f' onChange={handleChange}>
                    Ž
                </Radio>
            </Stack>
            </Center>
            </RadioGroup>
            </Box>
    )

}

export default MaleFemale;